export const ncdRouteMap = {
  gestion: {
    path: '/ncd/gestion',
    name: 'Gestion de Notas',
  },
  nuevo: {
    path: '/ncd/nuevo',
    name: 'Nueva Nota',
  },
  modificar: {
    path: `/ncd/modificar`,
    name: 'Edita Nota',
  },
}
